import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_outline.svg'


const _withScopeId = n => (_pushScopeId("data-v-28634a99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer bg-grey text-white" }
const _hoisted_2 = { class: "container py-2 h-100 d-flex flex-column" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md col-12 d-flex flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fs-4 fw-bold mb-3",
  style: {"vertical-align":"middle"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "col me-3 footer-logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode("H.E.R.O.")
], -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"col mt-auto text-end\" data-v-28634a99><a class=\"me-3\" href=\"https://www.facebook.com\" target=\"_blank\" data-v-28634a99><i class=\"fab fa-facebook-square fa-2x\" data-v-28634a99></i></a><a class=\"me-3\" href=\"https://www.youtube.com\" target=\"_blank\" data-v-28634a99><i class=\"fab fa-youtube-square fa-2x\" data-v-28634a99></i></a><a href=\"https://www.google.com\" target=\"_blank\" data-v-28634a99><i class=\"fab fa-google fa-2x\" data-v-28634a99></i></a></div>", 1)
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 offset-md-3 text-center fw-bolder text-grey" }, "copyright © 2023 H.E.R.O. All rights reserved.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('FOOTER'), (i) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "mb-1",
              href: i.LINK,
              target: "_blank"
            }, _toDisplayString(i.TITLE), 9, _hoisted_6))
          }), 256))
        ]),
        _hoisted_7
      ]),
      _hoisted_8
    ])
  ]))
}